/**
 * English Translation File
 */
export default {
	initializing: 'Initializing Application...',
	loading: 'Loading, please wait...',
	auth: {
		login_link: 'Login',
		forgot_password: {
			title: 'Enter your email and we\'ll send you a password reset link.',
			email: 'Email',
			submit_btn: 'Send Request'
		},
		password_reset: {
			title: 'Reset Password',
			email: 'Email',
			password: 'Password',
			password_confirm: 'Confirm Password',
			submit_btn: 'Reset Password'
		}
	},
	login: {
		welcome: 'Welcome back! Please login to your account.',
		forgot_password: 'Forgot Password',
		submit_btn: 'Login',
		server_error: {
			title: 'Login Error',
			message: 'The system is unable to log you in at this time. Please try again later.'
		},
		labels: {
			email: 'Email Address',
			password: 'Password',
			remember: 'Remember Me'
		},
		errors: {
			invalid: 'The provided credentials are invalid.'
		}
	},
	topbar: {
		app_title: 'Universal Dashboard'
	},
	nav: {
		dashboard: 'Dashboard',
		clients: 'Clients',
		connections: 'Connections',
		mag_templates: 'MAG Templates',
		logout: 'Logout',
		administration: 'Administration',
		expand: 'Expand Sidebar',
		collapse: 'Collapse Sidebar',
		translator_servers: 'Translator Servers',
		search: 'Search',
		users: 'Users'
	},
	clients: {
		none: 'No Clients Found',
		add_new: 'Add a New Client',
		edit: 'Edit Existing Client',
		name: 'Client Name',
		connections: 'Connections',
		choose_connection: 'Choose a Connection',
		online_status_threshold: 'Online Status Threshold',
		online_status_threshold_help: 'Online status threshold is the time in minutes within which devices should check-in with the server before they are considered offline',
		active: 'Active',
		inactive: 'Inactive',
		connection: 'Connection',
		group: 'Group',
		device: 'Device',
		thresholdUnits: {
			minutes: 'Minutes',
			hours: 'Hours',
			days: 'Days',
			weeks: 'Weeks',
			years: 'Years'
		}
	},
	monitors: {
		types: {
			connection: 'Translator Connection Monitor',
			attribute: 'Device Attribute Monitor'
		},
		failed_action_title: 'On Failure',
		success_action_title: 'On Success',
		no_actions: 'No Actions',
		no_mag_assigned: 'No Monitor Action Groups Assigned',
		fail_if: 'If',
		add_new: 'Add New Monitor',
		active: 'Active',
		delete_confirm_title: 'Delete Monitor',
		delete_confirm_message: 'Please confirm the deletion of this Monitor.',
		activate_confirm_title: 'Activate Monitor',
		activate_confirm_message: 'Please confirm the activation of this Monitor.',
		deactivate_confirm_title: 'Deactivate Monitor',
		deactivate_confirm_message: 'Please confirm the deactivation of this Monitor. Any attached tickets will have to be manually resolved.',
		override_btn: 'Override',
		override_confirm_title: 'Override Monitor',
		override_confirm_message: 'Please confirm that you wish to override this Monitor.	This will deactivate the inherited monitor, and create a copy for this resource.',
		cron: {
			schedule: 'Schedule',
			days: {
				sun: 'Sun',
				mon: 'Mon',
				tues: 'Tues',
				wed: 'Wed',
				thurs: 'Thurs',
				fri: 'Fri',
				sat: 'Sat'
			},
			lastRun: 'Last Run',
			neverRun: 'Never Run',
			nextRun: 'Next Run',
			monitorDisabled: 'Monitor Disabled'
		}
	},
	mag_templates: {
		title: 'Monitor Action Group Templates',
		none: 'No Templates Found',
		add_new: 'Add a New MAG Template',
		name: 'Template Name',
		monitors: 'Linked Monitors',
		success_actions: 'Success Actions',
		failure_actions: 'Failure Actions',
		delete_confirm_title: 'Delete MAG Template',
		delete_confirm_message: 'Please confirm the deletion of this Monitor Action Group Template.',
		delete_action_group_confirm_title: 'Delete Action Group',
		delete_action_group_confirm_message: 'Please confirm the deletion of this Monitor Action Group.',
		edit: 'Edit MAG Template'
	},
	action_groups: {
		add_new: 'Add a New Action Group',
		success_action_header: 'On Success',
		failure_action_header: 'On Failure',
		set_action: 'Set Action'
	},
	monitor_actions: {
		add_new: 'Add a New Monitor Action'
	},
	client: {
		dashboard: 'Client Dashboard',
		notifications: 'Notifications',
		monitors: 'Monitors',
		monitors_title: 'Client Monitors',
		groups: 'Groups'
	},
	group: {
		unassigned: 'Unassigned Devices',
		assign: 'Assign to Group',
		assign_message: 'This will assign the following devices to a group:',
		assign_btn: 'Assign',
		unassign: 'Unassign Devices',
		unassign_message: 'This will unassign the following devices from this group:',
		unassign_btn: 'Unassign',
		no_devices_found: 'No Devices Found',
		no_devices_found_description: 'There are no unassigned devices for this client.',
		monitors_title: 'Group Monitors'
	},
	groups: {
		none: 'No Groups Found',
		add_new: 'Add a New Group',
		client: 'Client Name',
		name: 'Group Name',
		parent: 'Parent Group',
		parent_description: 'This group will be a subgroup of the parent.',
		active: 'Active',
		created_at: 'Created At',
		activate: 'Activate Selected',
		deactivate: 'Deactivate Selected',
		actions: 'Actions',
		edit: 'Edit Group'
	},
	validation: {
		required: 'This field is required.',
		email: 'This field must be a valid email address.',
		password_confirm: 'This field must match the given password.',
		numeric: 'This field must be a number.'
	},
	network: {
		server_error: {
			title: 'Server Error'
		}
	},
	device: {
		loading: 'Loading...',
		unique_id: 'Unique ID',
		display_name: 'Display Name',
		updated_at: 'Last Refresh',
		monitors_title: 'Device Monitors',
		table_column_status_label: 'Online Status'
	},
	modal: {
		ok: 'OK',
		save: 'Save',
		update: 'Update',
		cancel: 'Cancel'
	},
	widgets: {
		device_online_status: 'Device Online Status'
	},
	dropdown: {
		none: 'None'
	}
};
